import { render, staticRenderFns } from "./busOrg.vue?vue&type=template&id=0a74e02a&scoped=true&"
import script from "./busOrg.vue?vue&type=script&lang=js&"
export * from "./busOrg.vue?vue&type=script&lang=js&"
import style0 from "./busOrg.vue?vue&type=style&index=0&id=0a74e02a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74e02a",
  null
  
)

export default component.exports